<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { map } from 'lodash-es';
import store from '../../../store';
import SkiDiscount from '../../../components/ski/skipass/SkiDiscount';
import i18n from '../../../i18n';

export default {
  name: 'SkiDiscounts',
  components: {
    SkiDiscount,
  },
  computed: {
    ...mapGetters({
      discounts: 'skipass/getDiscounts',
      personCategories: 'skipass/getPersonCategories',
    }),
    ...mapState({
      season: state => state.skipass.season,
      discountsLoading: state => state.skipass.season.discounts.itemsLoading,
      discountsError: state => state.skipass.season.discounts.itemsError,
      discountSaveLoading: state => state.skipass.season.discounts.saveLoading,
      discountSaveError: state => state.skipass.season.discounts.saveError,
      personCategoriesLoading: state => state.skipass.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skipass.season.personCategories.itemsError,
      personCategoriesSaveLoading: state =>
        state.skipass.season.discounts.personCategories.saveLoading,
      personCategoriesSaveError: state => state.skipass.season.discounts.personCategories.saveError,
    }),
    isNewDiscountActive() {
      return this.discounts.some(discount => discount.id === undefined);
    },
    errorOccurred() {
      return this.discountsError
        || this.discountSaveError
        || this.personCategoriesError
        || this.personCategoriesSaveError;
    },
    availablePersonCategoriesMapped() {
      if (!this.personCategories) {
        return [];
      }
      return map(this.personCategories, personCategory => ({
        id: personCategory.id,
        name: personCategory.name,
      })).sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    ...mapActions({
      loadDiscounts: 'skipass/discountsBySeasonIdLoad',
      addNewDiscount: 'skipass/discountAddNew',
      createDiscount: 'skipass/discountCreate',
      saveDiscount: 'skipass/discountSave',
      removeDiscount: 'skipass/discountRemove',
      savePersonCategoryOnDiscount: 'skipass/personCategoryOnDiscountSave',
      deletePersonCategoryOnDiscount: 'skipass/personCategoryOnDiscountDelete',
      setDiscount: 'skipass/setDiscount',
    }),
    createOrUpdate(discount) {
      if (discount.id) {
        this.saveDiscount(discount);
      } else {
        this.createDiscount(discount);
      }
    },
    remove(discountId) {
      // eslint-disable-next-line no-alert
      if (!discountId || confirm(i18n.t('ski.skiDiscount.removeAreYouSure'))) {
        this.removeDiscount(discountId);
      }
    },
    syncSelectedPersonCategories(newSelectedPersonCategories, discount) {
      discount.personCategories.forEach((oldPersonCategoryId) => {
        const selectedPersonCategoryId = newSelectedPersonCategories.find(
          newPersonCategory => newPersonCategory === oldPersonCategoryId,
        );
        if (!selectedPersonCategoryId) {
          this.deletePersonCategoryOnDiscount({
            discountId: discount.id,
            personCategoryId: oldPersonCategoryId,
          });
        }
      });
      newSelectedPersonCategories.forEach((newPersonCategoryId) => {
        const selectedPersonCategoryId = discount.personCategories.find(
          oldPersonCategoryId => oldPersonCategoryId === newPersonCategoryId,
        );
        if (!selectedPersonCategoryId) {
          const newItem = this.personCategories.find(item => item.id === newPersonCategoryId);
          this.savePersonCategoryOnDiscount({
            discountId: discount.id,
            newItem: {
              id: newItem.id,
              name: newItem.name,
            },
          });
        }
      });
    },
    onDiscountChange(payload) {
      this.setDiscount(payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('skipass/personCategoriesByIdLoad', to.params.seasonId)
      .finally(() => {
        next();
      });
    store.dispatch('skipass/discountsBySeasonIdLoad', to.params.seasonId)
      .finally(() => {
        next();
      });
  },
};
</script>

<template>
  <v-container class="pa-0">
    <div class="py-2">
      <div>
        <h2 class="d-inline-block">
          {{ $t('ski.skiDiscount.title') }}
          ({{ Object.keys(this.discounts).length }})
        </h2>
        <v-btn
          @click="this.addNewDiscount"
          :disabled="isNewDiscountActive"
          class="mb-2"
          color="success"
          outline
        >
          {{ $t('ski.skiDiscount.new') }}
        </v-btn>
        <v-btn
          @click="loadDiscounts(season.id)"
          :loading="discountsLoading"
          icon
        >
          <v-icon>cached</v-icon>
        </v-btn>
      </div>
      <div class="text-center">
        <v-progress-linear
          v-if="this.discountsLoading
            || this.discountSaveLoading
            || this.personCategoriesLoading
            || this.personCategoriesSaveLoading"
          :indeterminate="true"
        />
      </div>
      <v-alert
        :value="this.errorOccurred"
        color="error"
        icon="warning"
        outline
      >
        <span v-html="errorOccurred"></span>
      </v-alert>
      <v-layout
        v-for="(discount, index) in discounts"
        :key="'ski-discounts-' + index"
        wrap
      >
        <ski-discount
          @onChange="onDiscountChange"
          @createOrUpdate="createOrUpdate"
          @remove="remove"
          @syncSelectedPersonCategories="syncSelectedPersonCategories"
          :discount="discount"
          :availablePersonCategories="availablePersonCategoriesMapped"
          :seasonId="season.id"
          :loading="discountsLoading || personCategoriesLoading"
          :save-loading="discountSaveLoading || personCategoriesSaveLoading"
        />
      </v-layout>
    </div>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skipass/SkiPassSeasonDiscounts.vue